module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDM2IDM2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMxODRFNzgiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMjQuOTc1IDEzLjExTDE2LjEzIDI2LjYzbC0uMjg3LS40MTEuMjQ1LTcuNDk1LTYuMjc5LTIuMDU3IDE1LjE2Ny0zLjU1NnoiLz4KICAgIDwvZz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/go-to.svg
// module id = 2743
// module chunks = 0